import { Card, Checkbox, Flex, Progress, Title } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import React from "react";
import {
  useDeleteProjectByProjectIdIssueTodosDeleteMutation,
  usePostProjectByProjectIdIssueTodosAddMutation,
  usePutProjectByProjectIdIssueTodosToggleMutation,
  usePutProjectByProjectIdIssueTodosUpdateMutation,
  usePutProjectByProjectIdIssueUpdateSimpleMutation,
} from "../../../../../../../openapi";
import { TodoList } from "../../../../../../components";
import FoldableSection from "../../../../../../components/FoldableSection/FoldableSection";

export const IssueTodoSection: React.FC<{ issue: IIssueApi; projectId: string }> = ({ issue, projectId }) => {
  const [addTodo] = usePostProjectByProjectIdIssueTodosAddMutation();
  const [updateTodo] = usePutProjectByProjectIdIssueTodosUpdateMutation();
  const [toggleTodo] = usePutProjectByProjectIdIssueTodosToggleMutation();
  const [deleteTodo] = useDeleteProjectByProjectIdIssueTodosDeleteMutation();
  const [updateValue] = usePutProjectByProjectIdIssueUpdateSimpleMutation();

  return (
    <FoldableSection storageKey="issue-modal-todo">
      <FoldableSection.Header>
        <Flex>
          <Title order={6}>Sjekkliste</Title>
          <Flex flex={1} align="center" gap="sm">
            {issue.todos?.length > 0 ? (
              <Progress
                mb="xs"
                value={(issue.todos.filter((todo) => todo.completedByName != null).length / issue.todos.length) * 100}
                size="xs"
                flex={1}
              />
            ) : (
              <Flex flex={1} />
            )}

            <Checkbox
              label="Vis i kanban"
              checked={issue.showTodosInKanban === true}
              onChange={() =>
                updateValue({
                  projectId,
                  body: { _id: issue._id, property: { showTodosInKanban: !issue.showTodosInKanban } },
                })
              }
            />
          </Flex>
        </Flex>
        <Flex align="center" className="section-title"></Flex>
      </FoldableSection.Header>
      <FoldableSection.Body>
        <Card w="100%" bg="#f8f9fa" bd="1px solid var(--mantine-color-warmgray-2)">
          <TodoList
            todos={issue.todos}
            addNewTodo={async (text) =>
              await addTodo({
                projectId,
                body: { issueId: issue._id, todoText: text },
              })
            }
            updateTodo={async (_id, text) => {
              await updateTodo({
                projectId,
                body: { issueId: issue._id, text: text, todoId: _id },
              });
            }}
            deleteTodo={async (_id) => {
              await deleteTodo({
                projectId,
                issueId: issue._id,
                todoId: _id,
              });
            }}
            toggleTodo={async (_id, isChecked) => {
              await toggleTodo({
                projectId,
                body: { issueId: issue._id, todoId: _id, isChecked },
              });
            }}
          />
        </Card>
      </FoldableSection.Body>
    </FoldableSection>
  );
};
